export default __webpack_public_path__ + "static/media/down.8d7e872c.svg";